import React from "react";
import "./Tools.css";


  const tools = [
    { name: "Google Calendar", logo: "/google-calendar.png" },
    { name: "Calendly", logo: "/calendly.png" },
    { name: "Gmail", logo: "/google-email.png" },
    { name: "OneDrive", logo: "/onedrive.png" },
    { name: "Google Sheet", logo: "/google-sheet.jpg" },
    { name: "Trello", logo: "/trello.png" },
    { name: "Asana", logo: "/asana.png" },
    { name: "ClickUp", logo: "/clickup.png" },
    { name: "Notion", logo: "/notion.jpg" },
    { name: "Slack", logo: "/slack.png" },
    { name: "Zoom", logo: "/zoom.png" },
    { name: "Canva", logo: "/canva.jpg" },
    { name: "HubSpot", logo: "/hubspot.png" },
    { name: "Salesforce", logo: "/salesforce.jpg" },
    { name: "Zendesk", logo: "/zendesk.png" },
    { name: "Hootsuite", logo: "/hootsuite.png" },
    { name: "Buffer", logo: "/buffer.png" },
    { name: "Meta", logo: "/meta.png" },
    { name: "LinkedIn", logo: "/linkedin.png" },
    { name: "TikTok", logo: "/tiktok.png" },
    { name: "Instagram", logo: "/instagram.jpg" }
  ];

  const Tools = () => {
    return (
      <section className="tools-section">
        <div className="container">
          <h2 className="section-title">Tools I Use</h2>
          <p className="section-description">
            A selection of tools that help streamline my workflow.
          </p>
  
          <div className="tools-grid">
            {tools.map((tool, index) => (
              <div key={index} className="tool-card">
                <img
                  src={process.env.PUBLIC_URL + tool.logo}
                  alt={tool.name}
                  className="tool-logo"
                />
                <p className="tool-name">{tool.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  };
  
  export default Tools;
  
  